export const MAX_ATTACHMENT_SIZE = 10 * 1024 * 1024;
export const MAX_ATTACHMENT_NAME_LENGTH = 100;
export const ACCEPTED_ATTACHMENTS_FORMATS = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf'];
